
import { Dispatch } from "redux";
import { GET_PARAMS } from "./paramHelper";

export const RECEIVE_REPORT_CONFIGS = 'RECEIVE_REPORT_CONFIGS'

export const fetchReportConfigs = (token: string) => async (dispatch: Dispatch) => {
  return await fetch("/api/report-configs", GET_PARAMS(token)).then(async response => {
    const { configs } = await response.json();

    return dispatch({
      type: RECEIVE_REPORT_CONFIGS,
      configs
    });
  });
};